import { useEffect } from 'react'
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'
import useIsMount from 'helpers/useIsMount'

import { NotFound } from 'js/core/NotFound'
import { onlyTypename } from 'js/lib/helpers/onlyTypename'

import Layout from './Layout/Layout'
import { MagazineViewProvider } from './MagazineViewContext'
import { MAGAZINE_ISSUE_VIEW } from './View.queries'

const View = () => {
    const { containerGuid } = useParams()

    const { loading, data, refetch } = useQuery(MAGAZINE_ISSUE_VIEW, {
        variables: {
            guid: containerGuid,
        },
    })

    const magazineIssue = onlyTypename(data?.entity, 'MagazineIssue')
    const magazineArticles = magazineIssue?.articles.map((article) =>
        onlyTypename(article, 'Blog'),
    )

    // TODO: removed fix otherwise
    const isMount = useIsMount()

    useEffect(() => {
        if (isMount) {
            // Fetch all articles after creating a new article
            refetch()
        }
    }, [isMount, refetch])

    if (loading) {
        return null
    }

    if (!data || !magazineIssue) {
        return <NotFound />
    }

    return (
        <MagazineViewProvider
            value={{ magazineIssue, articles: magazineArticles }}
        >
            <Layout />
        </MagazineViewProvider>
    )
}

export default View
